import React, { useState } from "react";
import { Alert, Snackbar } from "@mui/material";
import FileDownloadRoundedIcon from "@mui/icons-material/FileDownloadRounded";

const DownloadPresetBackup = ({ presets }) => {
  const [error, setError] = useState("");

  const downloadBackup = () => {
    try {
      // Export this account's full local view, including unsynced edits and
      // presets hidden by the daily-routine filter.
      if (!Array.isArray(presets)) {
        throw new Error("Invalid preset data");
      }

      const now = new Date();
      const pad = (value) => String(value).padStart(2, "0");
      const timestamp = `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())}_${pad(now.getHours())}-${pad(now.getMinutes())}-${pad(now.getSeconds())}-${String(now.getMilliseconds()).padStart(3, "0")}`;
      const backup = {
        version: 1,
        exportedAt: now.toISOString(),
        // Include the local time and offset as well as the UTC timestamp.
        exportedAtLocal: now.toString(),
        userPandaPresets: presets,
      };
      const blob = new Blob([JSON.stringify(backup, null, 2)], {
        type: "application/json",
      });
      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = `my-presets-backup_${timestamp}.json`;
      document.body.appendChild(link);
      try {
        link.click();
      } finally {
        link.remove();
        // Give the browser time to start downloading before releasing the URL.
        setTimeout(() => URL.revokeObjectURL(url), 1000);
      }
    } catch (error) {
      setError("Could not download your preset backup. Please try again.");
    }
  };

  return (
    <>
      <button
        type="button"
        className="my-presets-footer-button"
        title="Download all presets as JSON"
        aria-label="Download all presets as JSON"
        onClick={downloadBackup}
      >
        <FileDownloadRoundedIcon />
      </button>
      <Snackbar open={Boolean(error)} autoHideDuration={6000} onClose={() => setError("")}>
        <Alert severity="error" onClose={() => setError("")}>
          {error}
        </Alert>
      </Snackbar>
    </>
  );
};

export default DownloadPresetBackup;
